import InvitationComponent from '@app/components/account/invitation/invitation.component';
import ResetPasswordComponent from '@app/components/account/reset-password/reset-password';
import SigninComponent from '@app/components/account/signin/signin';
import QuickSignUpComponent from '@app/components/account/signup/quick/quick-sign-up.component';
import SignupComponent from '@app/components/account/signup/signup';
import HeaderComponent from '@app/components/core/header/header';
import SidebarComponent from '@app/components/core/sidebar/sidebar';
import * as models from '@app/models/index';
import { CssBaseline, Hidden } from '@material-ui/core';
import * as React from 'react';
import { Provider } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router';
import { renderRoutes } from 'react-router-config';
import { Unsubscribe } from 'redux';
import 'typeface-roboto';
import * as packageJson from '../package.json';
import { AccountStatusEnum, UserRole } from './app.enum';
import applyAxiosInterceptors from './app.interceptor';
import { AppRoutes } from './app.routes';
import store from './app.store';
import './assets/styles/styles.css';
import { handleZendeskWidget } from './handle-zendesk';
import { withAppModule } from './providers/app-module.provider';
import withMediaQueries from './providers/media-query.provider';

class AppComponent extends React.Component<models.IAppComponentProps, models.IAppComponentState> {
	private unsubscribe: Unsubscribe;

	constructor(props: models.IAppComponentProps) {
		super(props);

		// If this.props.mediaQueryMatches=true, that mean we are on small screen,
		// so sidebar should be initially closed
		this.state = models.initialAppState(this.props.mediaQueryMatches ? false : true);
		applyAxiosInterceptors();
		this.bindFunctions();
	}

	public componentDidMount() {
		this.unsubscribe = store.subscribe(() => {
			const authentication = store.getState().authentication;
			this.setState({
				isAuthenticated: authentication.isAuthenticated,
				status: authentication.status,
				userRole: authentication.user ? authentication.user.role : UserRole.User,
			});
		});

		if (store.getState().authentication.user) {
			this.filterAppRoutes(store.getState().authentication.status, store.getState().authentication.user.role);
		}

		this.setState((currentState) => ({
			...currentState,
			sidebarOpen: this.props.mediaQueryMatches ? false : true,
		}));
	}

	// componentDidUpdate called after updation of every state
	public componentDidUpdate(prevProps: models.IAppComponentProps, prevState: models.IAppComponentState) {
		if (prevState.status !== this.state.status || prevState.userRole !== this.state.userRole) {
			this.filterAppRoutes(this.state.status, this.state.userRole);
		}

		handleZendeskWidget(this.state.isAuthenticated);

		if (prevProps.mediaQueryMatches !== this.props.mediaQueryMatches) {
			this.setState((currentState) => ({
				...currentState,
				sidebarOpen: this.props.mediaQueryMatches ? false : true,
			}));
		}
	}

	public componentWillUnmount() {
		this.unsubscribe();
	}

	public render() {
		let components: React.ReactNode;
		if (this.state.isAuthenticated) {
			components = (
				<React.Fragment>
					<HeaderComponent sidebarOpen={this.state.sidebarOpen} onSidebarToggle={this.onSidebarToggle} />
					<Hidden smUp={true}>
						<SidebarComponent
							variant='temporary'
							open={this.state.sidebarOpen}
							onToggle={this.onSidebarToggle}
							version={packageJson.version}
						/>
					</Hidden>
					<Hidden xsDown={true}>
						<SidebarComponent
							variant='permanent'
							open={this.state.sidebarOpen}
							onSidebarOpen={this.onSidebarOpen}
							onToggle={this.onSidebarToggle}
							version={packageJson.version}
						/>
					</Hidden>
					<div className='app-content'>
						<div className='main-content'>
							<div className='container'>{renderRoutes(this.state.routes)}</div>
						</div>
					</div>
				</React.Fragment>
			);
		} else {
			components = (
				<React.Fragment>
					<div className='app-content'>
						<Switch>
							<Route path='/signin' component={SigninComponent} />
							<Route path='/signup' component={SignupComponent} exact={true} />
							<Route path='/signup/quick' component={QuickSignUpComponent} exact={true} />
							<Route path='/reset-password' component={ResetPasswordComponent} />
							<Route path='/invitation' component={InvitationComponent} exact={true} />
							<Route render={this.redirectToSignin} />
						</Switch>
					</div>
				</React.Fragment>
			);
		}

		return (
			<Provider store={store}>
				<CssBaseline />
				<div className='root'>{components}</div>
			</Provider>
		);
	}

	private redirectToSignin() {
		return <Redirect to='/signin' />;
	}

	private onSidebarToggle() {
		this.setState((currentState) => ({ ...currentState, sidebarOpen: !this.state.sidebarOpen }));
	}

	private onSidebarOpen() {
		this.setState((currentState) => ({ ...currentState, sidebarOpen: true }));
	}

	private filterAppRoutes(accountStatus: AccountStatusEnum, userRole: UserRole) {
		this.setState({
			routes: AppRoutes.filter((x) => x.accountStatuses.includes(accountStatus) && x.userRoles.includes(userRole)),
		});
	}

	private bindFunctions() {
		this.redirectToSignin = this.redirectToSignin.bind(this);
		this.onSidebarToggle = this.onSidebarToggle.bind(this);
		this.onSidebarOpen = this.onSidebarOpen.bind(this);
		this.filterAppRoutes = this.filterAppRoutes.bind(this);
	}
}

export default withRouter(withAppModule(withMediaQueries(AppComponent, (muitheme) => muitheme.breakpoints.down('sm'))));



// WEBPACK FOOTER //
// ./src/app.component.tsx